import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.regexp.replace";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
import { stringify } from 'qs';
import keys from 'lodash/keys';
import * as types from './types';
import fetchCategory from '~/services/category';
var MOCK_ORIGIN_URL = 'https://mock';
export default {
  fetchContent: function () {
    var _fetchContent = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(_ref, _ref2) {
      var commit, alias, query, profileId, _ref3, category, details, total, products, earlybirdsWidgets, currentLocale, currentQuery, currentAlias, isRedirect, redirectData, url, redirectUrl;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit;
              alias = _ref2.alias, query = _ref2.query, profileId = _ref2.profileId;
              _context.next = 4;
              return fetchCategory(this, alias, query, profileId);

            case 4:
              _ref3 = _context.sent;
              category = _ref3.category;

              if (category) {
                _context.next = 9;
                break;
              }

              commit(types.SET_PRODUCTS, {
                products: [],
                total: 0
              });
              return _context.abrupt("return");

            case 9:
              details = category.details, total = category.total, products = category.products, earlybirdsWidgets = category.earlybirdsWidgets;
              currentLocale = this.state.i18n.currentLocale;
              currentQuery = keys(query).length ? "?".concat(stringify(query)) : '';
              currentAlias = "".concat(details.slug, "-").concat(details.hash);

              if (alias !== currentAlias && process.server && details.slug !== null) {
                this.app.context.redirect(301, "/".concat(currentLocale.market, "/").concat(currentLocale.language, "/c/").concat(currentAlias).concat(currentQuery));
              }

              isRedirect = details.routing && details.routing.isRedirect;

              if (!isRedirect) {
                _context.next = 19;
                break;
              }

              redirectData = details.routing;

              if (process.server && redirectData.newUrl) {
                this.app.context.redirect(redirectData.httpCode, "".concat(redirectData.newUrl).concat(currentQuery));
              } else {
                url = new URL(redirectData.newUrl, MOCK_ORIGIN_URL);
                redirectUrl = url.href.replace('mock/', '');

                if (redirectUrl.match(/^\/[A-Z]{2}\/[a-z]{2}\/(?:c|e|p|q|s)\//)) {
                  this.app.context.redirect(301, "".concat(redirectUrl).concat(currentQuery));
                } else {
                  window.location.href = "".concat(redirectUrl).concat(currentQuery);
                }
              }

              return _context.abrupt("return");

            case 19:
              commit(types.SET_DESCRIPTION, _objectSpread({}, details, {
                earlybirdsWidgets: earlybirdsWidgets
              }));
              commit(types.SET_PRODUCTS, {
                products: products,
                total: total
              });

            case 21:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function fetchContent(_x, _x2) {
      return _fetchContent.apply(this, arguments);
    }

    return fetchContent;
  }(),
  appendProducts: function () {
    var _appendProducts = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee2(_ref4, _ref5) {
      var commit, alias, query, profileId, _ref6, products;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              commit = _ref4.commit;
              alias = _ref5.alias, query = _ref5.query, profileId = _ref5.profileId;
              _context2.next = 4;
              return fetchCategory(this, alias, query, profileId);

            case 4:
              _ref6 = _context2.sent;
              products = _ref6.category.products;
              commit(types.APPEND_PRODUCTS, products);

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function appendProducts(_x3, _x4) {
      return _appendProducts.apply(this, arguments);
    }

    return appendProducts;
  }(),
  prependProducts: function () {
    var _prependProducts = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee3(_ref7, _ref8) {
      var commit, alias, query, profileId, _ref9, products;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              commit = _ref7.commit;
              alias = _ref8.alias, query = _ref8.query, profileId = _ref8.profileId;
              _context3.next = 4;
              return fetchCategory(this, alias, query, profileId);

            case 4:
              _ref9 = _context3.sent;
              products = _ref9.category.products;
              commit(types.PREPEND_PRODUCTS, products);

            case 7:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function prependProducts(_x5, _x6) {
      return _prependProducts.apply(this, arguments);
    }

    return prependProducts;
  }()
};